(function(){
    'use strict';

    angular
    .module('app')
    .controller('ReferencedmodelconfigController', ReferencedmodelconfigController)
 
    ReferencedmodelconfigController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function ReferencedmodelconfigController($http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.json = "";
        vm.nodetype = "";
        vm.multiple = false;
        vm.field = "";
        vm.orden = "";
        vm.where = "";
        vm.fields = "";
        vm.update = function(){
            var j = JSON.parse($('#fieldconfig-value').val());

			
            j.references["nodeType"] = vm.nodetype;
            j.references["field"] = vm.field;
            j.references["orden"] = vm.orden;
            j.references["multiple"] = vm.multiple;
            j.references["modificar"] = vm.modificar;
            j.references["where"] = vm.where;
            j.references["fields"] = vm.fields;

			vm.scopeParent.$parent.fieldsVm.jsonValue = angular.toJson(j);
			$('#fieldconfig-value').val(vm.scopeParent.$parent.fieldsVm.jsonValue);
        };
        vm.init = function(scopeParent){
        	vm.scopeParent = scopeParent;
        	//console.log(scopeParent);
        	var valorJson = $('#fieldconfig-value').val();
        	if(valorJson != ""){
        		vm.json = JSON.parse(valorJson);
                if(typeof vm.json.references.multiple!='undefined'){
                    vm.multiple = vm.json.references.multiple;
                }
                if(typeof vm.json.references.modificar!='undefined'){
                    vm.modificar = vm.json.references.modificar;
                }
                if(typeof vm.json.references.orden!='undefined'){
                    vm.orden = vm.json.references.orden;
                }
        	}
        	vm.update();
        };
    } 

})();